// extracted by mini-css-extract-plugin
module.exports =  {"LeftMenu":"LMxK3cGnbcghMhESxC0w"};